import { render, staticRenderFns } from "./ai-memory-updates-dialog.vue?vue&type=template&id=83e21b1a&scoped=true&"
import script from "./ai-memory-updates-dialog.vue?vue&type=script&lang=js&"
export * from "./ai-memory-updates-dialog.vue?vue&type=script&lang=js&"
import style0 from "./ai-memory-updates-dialog.vue?vue&type=style&index=0&id=83e21b1a&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "83e21b1a",
  null
  
)

export default component.exports